import { takeEvery, all, put, select } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'
import { updateLevel } from '../actions'
import { push } from 'connected-react-router'
import { EDIT_LEVEL_FORM_NAME as FORM_NAME } from 'app/constants/levels'
import { showSuccess } from 'store/entities/toastr/utils'
import { getViewProtrackId } from 'store/entities/protracks/selectors'
import { MICROACTIONS_PATH } from 'app/constants/navLinks'

export function* handlePutRequest({ payload }) {
  yield put(startSubmit(FORM_NAME))
}

export function* handlePutSuccess({ payload: { data } }) {
  const protrackId = yield select(getViewProtrackId)
  yield put(push(`${MICROACTIONS_PATH}/protracks/${protrackId}`, { forceLeave: true }))
  showSuccess({ content: `You successfully updated Level "${data.order}"` })
}

export function* handlePutFail(error) {
  console.error('error', error)
  yield put(stopSubmit(FORM_NAME))
}

export default function* updateLevelSaga() {
  yield all([
    takeEvery(updateLevel.toString(), handlePutRequest),
    takeEvery(updateLevel.success.toString(), handlePutSuccess),
    takeEvery(updateLevel.fail.toString(), handlePutFail),
  ])
}
